import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {FooterModuleTerms} from "./footer-module.terms";
import {FooterModuleRemoteConfig} from "./footer-module.remote-config";

export class FooterModuleConfig extends BaseConfig {

  static injectables = [FooterModuleTerms, FooterModuleRemoteConfig];

  constructor(terms: FooterModuleTerms, remoteConfig: FooterModuleRemoteConfig){
    super('footerModule', null, terms, remoteConfig);
  }
}
